import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadJournalDetails = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/Journal/GetJournals', {
        SiteId: defaultSite.id,
        WhoCalled: null,
        ExcludeCompleted: false,
        JournalDate: date,
        GetSevenData: true
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "JournalDetails");
            offlineService.addOffline(defaultSite.id, "JournalDetails", result);
        },
            (error) => {
                console.log(error);
            });
};

const LoadWhoCalledItems = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/Journal/GetWhoCalleds', {
        siteId: defaultSite.id
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GetWhoCalleds");
            offlineService.addOffline(defaultSite.id, "GetWhoCalleds", result);
        },
            (error) => {
                console.log(error);
            });
};

const SaveJournalOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, item);
        }
        else {
            //offlineSyncService.removeById(exists.Id);
            //id = await offlineSyncService.add(siteId, pId, url, keyName, item);
            offlineSyncService.updateById(exists.Id, item);
            id = exists.Id;
        }
    }

    UpdateOfflineData(siteId, item, remove);
    return id;
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "JournalDetails");
    const data = offlineResult.OfflineData.data;
    const index = data.findIndex(d => d.AppJournalId === item.AppJournalId);

    if (remove) {
        offlineResult.OfflineData.data.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.data.push(item);
    else {
        offlineResult.OfflineData.data[index] = item;
    }

    const whoCalledsResult = await offlineService.getOfflinesBySite(siteId, "GetWhoCalleds");
    const whoCalleds = whoCalledsResult.OfflineData;
    const hasData = whoCalleds.findIndex(d => d === item.WhoCalled);
    if (hasData === -1) {
        console.log(item.WhoCalled);
        whoCalledsResult.OfflineData.push(item.WhoCalled);
        offlineService.updateOfflineByName(siteId, "GetWhoCalleds", whoCalledsResult.OfflineData);
    }

    offlineService.updateOfflineByName(siteId, "JournalDetails", offlineResult.OfflineData);
};

export { LoadJournalDetails, LoadWhoCalledItems, SaveJournalOfflineData };
